import { Box, Typography, Stack, Button } from '@mui/material';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import classNames from 'classnames/bind';
import images from '~/assets/images';
import styles from './AvatarName.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import { useState, useEffect } from 'react';

const cx = classNames.bind(styles);

const AvartarName = () => {
    const [user, setUser] = useState(null);

    const profile = useSelector((state) => state.profile?.list?.data);
    const auth = useSelector((state) => state.auth);

    useEffect(() => {
        console.log(auth);
        if (auth.user) {
            setUser(JSON.parse(auth.user));
        }
    }, [auth]);

    return (
        <Box className={cx('AvatarName')} textAlign="center">
            <Box>
                <img
                    style={{ width: '100px', height: '100px', border: '2px solid #dee2e6', borderRadius: '50%' }}
                    src={profile?.image ? profile?.image : images.avatarDefault}
                    alt=""
                />
            </Box>
            <Typography sx={{ fontSize: '20px' }}>{user ? user.name : 'Chưa cập nhật'}</Typography>
            <Typography sx={{ fontSize: '16px', color: '#777777' }}>
                        {user?.account_type === "CUSTOMER" && "Tài khoản thường"}
                        {user?.account_type === "PARTNER" && "Đối tác"}
                        {user?.account_type === "EXPERT" && "Chuyên gia"}
            </Typography>
        </Box>
    );
};

export default AvartarName;
